module.exports = __webpack_public_path__ + "img/logo-fill-adeagro.dcabc627.svg";